// ESTADOS PARA USUARIO LOGUEADO
export const isLoggedIn = state => state.isLoggedIn
export const dataUser = state => state.dataUser
